import React from "react";
import styles from "./Footer.module.css";
import { useNavigate } from "react-router-dom";

const KeyEnablers = ({ keyEnablers }) => {
  

  const navigate = useNavigate();

  return (
    <div
      className={styles.columnWrapperKey}
      data-aos="fade-right"
      data-aos-delay="300"
    >
      <div className={styles.columnContent}>
        <div className={styles.columnHeader}>
          <h3 className={styles.columnHeading}>
            <div className={styles.columnHeadingWrapper}>
              <div className={styles.columnHeadingText}>Key Enablers</div>
              <div className={styles.horizontalDivider} />
            </div>
            <div className={styles.columnHeadingUnderline} />
          </h3>
        </div>
        <ul className={styles.list}>
          {keyEnablers?.map((enabler, index) => (
            <li
              onClick={() => navigate(enabler.path)}
              key={index}
              className={styles.listItem}
              style={{ cursor: "pointer" }}
            >
              <div>{enabler.name}</div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default KeyEnablers;
